// extracted by mini-css-extract-plugin
export default {"a":"styles_a__qtn7R"};